import { Controller, Control, FieldError } from "react-hook-form";
import { useEffect, useState } from "react";
import { ReactComponent as EyeClosedIcon } from "../../assets/svg/icons/eyeClosed.svg";
import { ReactComponent as EyeOpenIcon } from "../../assets/svg/icons/eye.svg";
import InputMask from "react-input-mask";
import "./styles.css";

const PHONE_MASK = "(99) 99999-9999";

export type LoginHookFormInputVariant = "phone" | "password";

export type LoginHookFormInputProps = {
  variant: LoginHookFormInputVariant;
  control: Control<any>;
  label: string;
  error?: FieldError;
  id?: string;
  maxLength?: number;
  passwordField?: "password" | "confirmpassword";
};

export function LoginInput({
  variant,
  control,
  label,
  error,
  id,
  maxLength = 32,
  passwordField = "password",
}: LoginHookFormInputProps) {
  const name = variant === "phone" ? "phone" : passwordField;
  const [errorMessage, setErrorMessage] = useState("");
  const [hasError, setHasError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setHasError(!!error);
    if (error?.message && error.message !== " ") {
      setErrorMessage(error.message || "");
    } else {
      setErrorMessage("");
    }
  }, [error]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <>
          <div className={`textInput-label__container inputStatus${hasError ? "Error" : "Normal"}`}>
            <div className="textInput-label__content">
              <label htmlFor={id}>{label}</label>
              {variant === "phone" ? (
                <InputMask
                  {...field}
                  id={id}
                  type="tel"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                  autoComplete="tel"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck={false}
                  mask={PHONE_MASK}
                  alwaysShowMask={false}
                  // @ts-expect-error maskChar supported by react-input-mask
                  maskChar={null}
                />
              ) : (
                <input
                  {...field}
                  id={id}
                  type={showPassword ? "text" : "password"}
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck={false}
                  maxLength={maxLength}
                />
              )}
            </div>
            {variant === "password" && (
              <button type="button" onClick={() => setShowPassword((v) => !v)} id={id ? `toggleHide-${id}` : `toggleHide-${name}`}>
                {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </button>
            )}
          </div>
          {errorMessage ? (
            <small className="textInputwithlabel__error animation__fadeIn" id={id ? `error-${id}` : `error-${name}`}>
              {errorMessage}
            </small>
          ) : null}
        </>
      )}
    />
  );
}
